// auth.guard.ts
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { ACCESS_LEVELS } from '../constants';
import { ClientService } from '../services/client.service';
import { UtilitiesService } from '../services/utilities.service';

export const globalAdminAuthGuard: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    const utils = inject(UtilitiesService);
    const clientService = inject(ClientService);
    const router = inject(Router);

    if (!clientService.user() || !clientService.isGlobalAdmin()) {
        router.navigate(['/accessDenied']);
        return false;
    }

    const path = childRoute.url[0]?.path;
    const accessibilityMap = {
        globalAssessments: 'globalAdmin.globalAssessments',
        clients: 'globalAdmin.skillsMaster',
        globalMarketIntelligence: 'globalAdmin.globalMarketIntelligence',
        globalReports: 'globalAdmin',
        roles: 'globalAdmin.roles',
        users: 'globalAdmin',
        skillRecommendationIntegrations: 'globalAdmin.skillsMaster',
        skillsMaster: 'globalAdmin.skillsMaster'
    };
    const accessibility = accessibilityMap[path];

    if (accessibility && (utils.getDeepValue(clientService.user()?.role?.features, accessibility) ?? ACCESS_LEVELS.NO_ACCESS) === ACCESS_LEVELS.NO_ACCESS) {
        router.navigate(['/accessDenied']);
        return false;
    }

    return true;
};
